import * as React from "react";

// style, design
import * as SharedStyles from "../../../components/sharedStyles";

// store, state

import BookKeepingContainer from "../../../components/Billecta/BookKeeping/BookKeepingContainer";
import AccountingReportsContainer from "../../../components/Billecta/AccountingReports/AccountingReportsContainer";
import PageSlider from "../../Layouts/PageSlider/PageSlider";

import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";

const TABS = {
  BOOKKEEPING: "Inställningar",
  EXPORT: "Exporter",
};

function CompanyBookkeepingSettings() {
  const [selectedTab, setSelectedTab] = React.useState("BOOKKEEPING");

  return (
    <SharedStyles.DetailInnerWrapper>
      <SharedStyles.DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>Bokföring</OverviewTitle>
          <PageSlider
            {...{ TABS }}
            selectedTab={selectedTab}
            onTabSelected={setSelectedTab}
          />
        </OverviewTitleWrapper>

        {selectedTab === "EXPORT" && <AccountingReportsContainer />}
        {selectedTab === "BOOKKEEPING" && <BookKeepingContainer />}
      </SharedStyles.DetailPageBox>
    </SharedStyles.DetailInnerWrapper>
  );
}

export default CompanyBookkeepingSettings;
